
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexsZuyRPQNr8qEY87y94_45_45q_45rReUrUvxUcmflwVilf1xsMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/index.vue?macro=true";
import { default as indexNV5nKeH5T_5EMGl_45Dmh5iLMjZpYL6xLZ6MtGZlmvUXEMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/cart/index.vue?macro=true";
import { default as indexG4iKtfE_3kP4EW2Lb__45l_hfqJchK72XkFdIZK5GQ57IMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/login/index.vue?macro=true";
import { default as index8fFuW_45DUfiFhDPWAAJdM_FtUG9cQ6LHpZr_45OJZ7SBSEMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/logout/index.vue?macro=true";
import { default as index_m03YESTaN3UT11ndN4OAymTGw_YhULiVrnFFx1o6dsMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/contact/index.vue?macro=true";
import { default as indexI_r4sUct9PyQJJF1z3FmqYqSOukYvQJzLeLe2gJC4uYMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/checkout/index.vue?macro=true";
import { default as indexT1fnUOFhPyr0gV2_pudW_FU2STkZ4y3XSSSB2DQYkOcMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/myorders/index.vue?macro=true";
import { default as indexq_mxWPXcalEhEHuUblN6Hr0Vp32QrfPIcDrPnfcFEMoMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/index.vue?macro=true";
import { default as indexXZyLo9uhkQddM0pGlc_Kpfr3YwbGvZ7e60VsFjwPv2UMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/lookbooks/index.vue?macro=true";
import { default as list6YB0QkhhEToCyugvxPzzUo0O19PQTvkQAwvAgxJ__45PUMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/ra-support/list.vue?macro=true";
import { default as indexs8c7Q1spHauzL_45GsAIw_gbqgdNPJsyqNTGu20QFZLcAMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/openOrders/index.vue?macro=true";
import { default as indexmE8HmcdlY1_45bC_45UFIHUHXsCRZY3t8ieFYNowRZsuP6MMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/ra-support/index.vue?macro=true";
import { default as index5bletXn9dU1if3QX8YLBP17KWr9mYk7DFtlHRY62b9kMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/statements/index.vue?macro=true";
import { default as indexhD4FB_6qAFrSDErdNqft4mgBMOdVv9ZU_OD_AafWfqMMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/tradeshows/index.vue?macro=true";
import { default as indexn60zR9hQDnwik87fcL0VVwuu_kvDE0DZltsfVl3cnfkMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/admin/login/index.vue?macro=true";
import { default as indexbLY8JkN9GiFuPhOzSpTpebaWurWN3A3G3KjJT2Ui__UMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/creditMemos/index.vue?macro=true";
import { default as _91promotionName_93QssPFrlBMADA0HQXia5eLFwN8ZSn2YM6osqToMJilMgMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/p/[promotionName].vue?macro=true";
import { default as createzoSPqYsx_kjFYXfHa_45_u5zO9wDgrweZi2OFqQCThbcwMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/ra-support/create.vue?macro=true";
import { default as categoryMR6wYfePtW87EHKnFvD2ENquqF31UXWgCy_45ocpW3R9kMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/category.vue?macro=true";
import { default as resetPasswordFxLaKCC4tziz_45ctifwWuCVEAa_XOoCXn__e_NKdFY6kMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/user/resetPassword.vue?macro=true";
import { default as listIqAVmqbFiDqoliiMwJC3xCIpn5SFjJCN1nwJ6C6_gJUMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/style/list.vue?macro=true";
import { default as index1gr1Cnl6_vgy1YA_xZXAiTkWykS0639Y1div9Wo4aeQMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/color/index.vue?macro=true";
import { default as indexkLMkWNV6oKfDvJelQX06SDPdi0wto7odnXxltH4EChEMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/style/index.vue?macro=true";
import { default as indexS_45HxokT3g9srLWsnjAWhjRT_CY4EEEpSlFUNBRIynC8Meta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/barcode/index.vue?macro=true";
import { default as _91productNo_93O33H2iooYstEw8gpLeSsK5qcqVTxV_KTH3buA0Q4JkEMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/style/[productNo].vue?macro=true";
import { default as colorAndSizeChartspo__45_45cllziXMS3GFixcp9iKkTh8JhEzdFcnQHcRwdRQMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/colorAndSizeCharts.vue?macro=true";
import { default as indexmHUN2JmqDsYLA4XhyuKWMLcMPMyUPQe83QjaWB_4598fwMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/sizeAndColor/index.vue?macro=true";
import { default as indexPW4JIT93hAIjNWYOzGf9Z9kQ5ZDiz0Hm7C6i2j5dSGUMeta } from "C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/PriceAndColorAndSize/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexsZuyRPQNr8qEY87y94_45_45q_45rReUrUvxUcmflwVilf1xsMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/cart/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/login/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: index8fFuW_45DUfiFhDPWAAJdM_FtUG9cQ6LHpZr_45OJZ7SBSEMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/logout/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/contact/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/checkout/index.vue")
  },
  {
    name: "myorders",
    path: "/myorders",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/myorders/index.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: indexq_mxWPXcalEhEHuUblN6Hr0Vp32QrfPIcDrPnfcFEMoMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/index.vue")
  },
  {
    name: "lookbooks",
    path: "/lookbooks",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/lookbooks/index.vue")
  },
  {
    name: "ra-support-list",
    path: "/ra-support/list",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/ra-support/list.vue")
  },
  {
    name: "openOrders",
    path: "/openOrders",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/openOrders/index.vue")
  },
  {
    name: "ra-support",
    path: "/ra-support",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/ra-support/index.vue")
  },
  {
    name: "statements",
    path: "/statements",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/statements/index.vue")
  },
  {
    name: "tradeshows",
    path: "/tradeshows",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/tradeshows/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/admin/login/index.vue")
  },
  {
    name: "creditMemos",
    path: "/creditMemos",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/creditMemos/index.vue")
  },
  {
    name: "p-promotionName",
    path: "/p/:promotionName()",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/p/[promotionName].vue")
  },
  {
    name: "ra-support-create",
    path: "/ra-support/create",
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/ra-support/create.vue")
  },
  {
    name: "inventory-category",
    path: "/inventory/category",
    meta: categoryMR6wYfePtW87EHKnFvD2ENquqF31UXWgCy_45ocpW3R9kMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/category.vue")
  },
  {
    name: "user-resetPassword",
    path: "/user/resetPassword",
    meta: resetPasswordFxLaKCC4tziz_45ctifwWuCVEAa_XOoCXn__e_NKdFY6kMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/user/resetPassword.vue")
  },
  {
    name: "inventory-style-list",
    path: "/inventory/style/list",
    meta: listIqAVmqbFiDqoliiMwJC3xCIpn5SFjJCN1nwJ6C6_gJUMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/style/list.vue")
  },
  {
    name: "inventory-color",
    path: "/inventory/color",
    meta: index1gr1Cnl6_vgy1YA_xZXAiTkWykS0639Y1div9Wo4aeQMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/color/index.vue")
  },
  {
    name: "inventory-style",
    path: "/inventory/style",
    meta: indexkLMkWNV6oKfDvJelQX06SDPdi0wto7odnXxltH4EChEMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/style/index.vue")
  },
  {
    name: "inventory-barcode",
    path: "/inventory/barcode",
    meta: indexS_45HxokT3g9srLWsnjAWhjRT_CY4EEEpSlFUNBRIynC8Meta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/barcode/index.vue")
  },
  {
    name: "inventory-style-productNo",
    path: "/inventory/style/:productNo()",
    meta: _91productNo_93O33H2iooYstEw8gpLeSsK5qcqVTxV_KTH3buA0Q4JkEMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/style/[productNo].vue")
  },
  {
    name: "inventory-colorAndSizeCharts",
    path: "/inventory/colorAndSizeCharts",
    meta: colorAndSizeChartspo__45_45cllziXMS3GFixcp9iKkTh8JhEzdFcnQHcRwdRQMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/colorAndSizeCharts.vue")
  },
  {
    name: "inventory-sizeAndColor",
    path: "/inventory/sizeAndColor",
    meta: indexmHUN2JmqDsYLA4XhyuKWMLcMPMyUPQe83QjaWB_4598fwMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/sizeAndColor/index.vue")
  },
  {
    name: "inventory-PriceAndColorAndSize",
    path: "/inventory/PriceAndColorAndSize",
    meta: indexPW4JIT93hAIjNWYOzGf9Z9kQ5ZDiz0Hm7C6i2j5dSGUMeta || {},
    component: () => import("C:/N41PIM/N41_VENDOR_WEB/src/pages/inventory/PriceAndColorAndSize/index.vue")
  }
]